<template>
  <div class="legendContainer">

    <v-layout>
      <v-flex>
        <div class="ntstSectionTitle legendSectionHeader">Alerts</div>
      </v-flex>
    </v-layout>
    <v-divider class="legendDivider"></v-divider>
    <v-flex v-for="(code, index) of alerts" :key="`asc-${index}`" class="legendItem">
      <alert-visualized-coded-entry class="alert legendItemIcon" :visualized-coded-entry="code" :alertDisplayName="code.displayName"></alert-visualized-coded-entry>
      <span class="legendItemText">{{ code.displayName }}</span>
    </v-flex>

    <v-layout>
      <v-flex>
        <div class="ntstSectionTitle legendSectionHeader">Rooms</div>
      </v-flex>
    </v-layout>
    <v-divider class="legendDivider"></v-divider>
    <v-flex v-for="(code, index) of roomStatusCodes" :key="`rsc-${index}`" class="legendItem">
      <v-icon :style="codeSampleStyleUsingForeground(code)" class="legendItemIcon">fas fa-square-full</v-icon>
      <span class="legendItemText">{{ code.displayName }}</span>
    </v-flex>

    <v-layout>
      <v-flex>
        <div class="ntstSectionTitle legendSectionHeader">Clients</div>
      </v-flex>
    </v-layout>
    <v-divider class="legendDivider"></v-divider>
    <v-flex v-for="(code, index) of dischargeStatusCodes" :key="`dsc-${index}`" class="legendItem">
      <v-icon :style="codeSampleStyleUsingBackground(code)" class="legendItemIcon">fas fa-square-full</v-icon>
      <span class="legendItemText">{{ code.displayName }}</span>
    </v-flex>

  </div>
</template>

<script lang="js">
import AlertVisualizedCodedEntry from './AlertVisualizedCodedEntry.vue';

export default {
  name: 'LegendDrawer',
  data() {
    return {
    };
  },
  components: {
    'alert-visualized-coded-entry': AlertVisualizedCodedEntry
  },
  computed: {
    alerts() {
      return this.$store.getters.alertCodes;
    },
    dischargeStatusCodes() {
      return this.$store.getters.dischargeStatusCodes;
    },
    roomStatusCodes() {
      return this.$store.getters.roomStatusCodes;
    },
  },
  methods: {
    close() {

    },
    codeSampleStyleUsingBackground(code) {
      return {
        color: code.backgroundColorHexValue
      };
    },
    codeSampleStyleUsingForeground(code) {
      return {
        color: code.foregroundColorHexValue
      };
    },
  }
};
</script>

<style lang="scss">
.legendDivider {
  margin-bottom: 5px;
}
.legendItem {
  margin: 2px 0px 2px 15px;
}
.legendItemIcon {
  margin-right: 5px;
}
.legendItemText {
  vertical-align: middle;
}
.legendSectionHeader {
  margin: 7px 0px 5px 10px;
}
</style>
